module.exports = __webpack_public_path__ + "static/media/fotoslider-industrie-2.67c41dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/fotoslider-industrie-2.png
// module id = 366
// module chunks = 0